import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import ProductList from "./lists/productList";
import ProductForm from "./forms/productForm";
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import Modal from "../layout/Modal";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import Select from "../form/Select";
import {getComponentConfig} from "../../utils/components";
import isEqual from "lodash-es/isEqual";
import {AddressFormatter, ProductSelect, UnitFormatter} from "../../utils/formatters";
import Tabs from "../layout/Tabs";
import TabContent from "../layout/TabContent";
import {postData, sendRequest} from "../../utils/request";
import CheckBox from "../form/CheckBox";
import {isTrue} from "../../utils/other";
import ContentLoader from "../layout/ContentLoader";
import {connect} from "src/store";
import {store} from "src/store";
import {showModal} from "../../actions";
import classNames from "classnames";
import Icon from "../form/Icon";

class SortimentType extends React.Component {

    state = {
        sortiments: []
    }

    componentDidMount() {
        this.loadSortiments();
    }

    loadSortiments = () => {
        this.sortiments = sendRequest({
            option: "componentlist",
            component: "Sortiment",
            order: {field: "name", direction: "ASC"},
            itemsperpage: 0
        });
        this.sortiments.then((response) => {
            this.setState({
                isLoading: false,
                sortiments: response.items
            });
        });
    }

    render() {
        const all = (this.props.value || []).length + "" === "" + this.props.totalRecords && this.props.totalRecords + "" === "" + this.state.sortiments.length;
        return (
            <Box
                theme="default"
                header="Szortimentek"
                actions={<CheckBox
                    checked={all}
                    label="Összes"
                    disabled={this.props.loading || this.props.disabled}
                    saveChanges={() => {
                        if (!isTrue(all)) {
                            this.props.selectorgrid.addNewRows([...this.state.sortiments.filter((sortiment) => !(this.props.value || []).find((s) => s.id + "" === "" + sortiment.id))]);
                        } else {
                            this.props.selectorgrid.onItemsRemove([...this.state.sortiments]);
                        }
                    }}
                />}
            >
                {this.props.loading ? <ContentLoader/> : <div className="row">
                    {this.state.sortiments.map((sortiment, idx) => {
                        const checked = !!(this.props.value || []).find((s) => s.id + "" === "" + sortiment.id);
                        return <div className="col-md-2 col-lg-2 col-xs-6" key={idx}><div className="form-group"><CheckBox
                            name="optional"
                            type="bool"
                            value="1"
                            label={sortiment.name}
                            checked={checked}
                            disabled={this.props.loading || this.props.disabled}
                            saveChanges={(field, value) => {
                                if (isTrue(value)) {
                                    this.props.selectorgrid.addNewRows([sortiment]);
                                } else {
                                    this.props.selectorgrid.onItemRemove(sortiment);
                                }
                            }}
                        /></div></div>;
                    })}
                </div>}
            </Box>
        );
    }
}

class ProductChooser extends React.Component {

    show = () => {
        this.modal && this.modal.show();
    }

    hide = () => {
        this.modal && this.modal.hide();
    }

    render() {
        return (
            <Modal
                ref={(el) => this.modal = el}
                type="default"
                state={this.props.state}
                header="Új termék vagy kiadás?"
                buttons={[
                    {
                        text: 'Új kiadás',
                        onClick: async () => {
                            let values = JSON.parse(JSON.stringify({...this.props.newProto, newProtoType: true}));
                            if (this.props.newProduct) {
                                values = {...values, ...this.props.newProduct};
                            }
                            await this.props.setFormValues(values);
                            await this.props.setInitialValues({});
                            this.props.setState({newProduct: null});
                            this.modal && this.modal.hide();
                        }
                    },
                    {
                        text: 'Új termék',
                        onClick: async () => {
                            await this.props.pristineForm();
                            if (this.props.newProduct) {
                                await this.props.setFormValues({...this.props.values, ...this.props.newProduct});
                                await this.props.setInitialValues({});
                            }
                            this.props.setState({newProduct: null});
                            this.modal && this.modal.hide();
                        }
                    },
                    {
                        text: 'Mégse',
                        onClose: true,
                        onClick: () => {
                            this.modal && this.modal.hide();
                        }
                    }
                ]}
            />
        );
    }
}

class NewProductChooser extends React.Component {
    render() {
        return (
            <Modal
                ref={(el) => this.modal = el}
                state={this.props.state}
                type="default"
                header="Új termék vagy kiadás?"
                onClose={async () => {
                    this.props.onCancelNewProduct && await this.props.onCancelNewProduct();
                }}
            >
                <div className="row">
                    <Tabs
                        className="radio-style modal-tabs"
                        theme="default"
                        currentTab="newProduct"
                    >
                        <TabContent tabLabel="Új termék" tabName={"newProduct"}>
                            <div className="modal-footer with-footer-custom">
                                <div className="center-block">
                                    <Button
                                        color="default"
                                        onClick={async () => {
                                            this.props.onCancelNewProduct && await this.props.onCancelNewProduct();
                                        }}
                                    >
                                        Mégse
                                    </Button>
                                    <Button
                                        color="primary"
                                        onClick={async () => {
                                            await this.props.pristineForm();
                                            if (this.props.newProduct) {
                                                const values = JSON.parse(JSON.stringify({...values, ...this.props.newProduct}));
                                                await this.props.setFormValues(values);
                                                await this.props.setInitialValues({});
                                            }
                                            this.props.setState({newProduct: null});
                                        }}
                                    >
                                        Új termék
                                    </Button>
                                </div>
                            </div>
                        </TabContent>
                        <TabContent tabLabel="Új kiadás" tabName={"newEdition"}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <Select
                                            label={false}
                                            storeType="remote"
                                            placeholder="Vonalkód vagy cím"
                                            component="product"
                                            view={this.props.view}
                                            value={Object.keys(this.props.newProto).length ? this.props.newProto : null}
                                            valueKey={this.props.componentConfig.prototypefield}
                                            optionsTemplate={ProductSelect}
                                            saveChanges={(field, value) => {
                                                this.props.setState({newProto: {...this.props.getPrototype(JSON.parse(JSON.stringify(value)), this.props.componentConfig)}});
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer with-footer-custom">
                                <div className="center-block">
                                    <Button
                                        color="default"
                                        onClick={async () => {
                                            this.props.onCancelNewProduct && await this.props.onCancelNewProduct();
                                        }}
                                    >
                                        Mégse
                                    </Button>
                                    <Button
                                        color="primary"
                                        disabled={!Object.keys(this.props.newProto).length}
                                        onClick={async () => {
                                            await this.props.pristineForm();
                                            const values = JSON.parse(JSON.stringify({...this.props.newProto, ...(this.props.newProduct || {}), newProtoType: true}));
                                            await this.props.setFormValues(values);
                                            await this.props.setInitialValues({});
                                            this.props.setState({newProto: {}});
                                            this.props.setState({newProduct: null});
                                        }}
                                    >
                                        Új kiadás
                                    </Button>
                                </div>
                            </div>
                        </TabContent>
                    </Tabs>
                </div>
            </Modal>
        );
    }
}

const CheckStockButton = (props) => {
    return <Fragment>
        <Button
            size={props.size}
            color="default"
            icon={{lib: "fa", name: "info"}}
            onClick={async (e) => {
                e && e.preventDefault();
                e && e.stopPropagation();
                props.processAction(async () => {
                    const response = await postData({
                        action: props.componentConfig.componentname + ".checkStock",
                        data: {items: [{id: props.id}]}
                    });
                    store.dispatch(showModal({
                        size: "small",
                        theme: "default",
                        header: "Raktárkészlet",
                        body: UnitFormatter(response.items[0].stockqty || 0)
                    }));
                    return response;
                });
            }}
        />
    </Fragment>
}

class ProductEditor extends React.Component {

    state = {
        newProduct: null,
        newProto: {}
    }

    getPrototype = (values, config) => {
        const newValue = {...values};
        Object.keys(config.fielddefs).map((field) => {
            if (!config.fielddefs[field].prototype && config.prototypefield !== field) {
                delete newValue[field];
            }
        });
        return newValue;
    }

    constructor(props) {
        super(props);
        this.state.newProto = this.getPrototype(JSON.parse(JSON.stringify(this.props.values)), this.props.componentConfig);
        this.state.newProduct = this.props.newProduct;
    }

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    pristineForm = async () => {
        try {
            const value = await this.props.pristineForm();
            if (this.props.newProduct) {
                await this.promisedSetState({
                    newProduct: this.props.newProduct,
                    newProto: this.getPrototype(JSON.parse(JSON.stringify(this.props.values)), this.props.componentConfig)
                });
            }
            return value;
        } catch (e) {
            throw e;
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (
            (this.props.values[this.props.componentConfig.idfield] !== prevProps.values[this.props.componentConfig.idfield]
                &&
                this.props.values[this.props.componentConfig.prototypefield] !== prevProps.values[this.props.componentConfig.prototypefield])
            ||
            !isEqual(this.props.newProduct, prevProps.newProduct)
        ) {
            if (JSON.stringify(this.props.newProduct) !== JSON.stringify(this.state.newProduct) || JSON.stringify(this.getPrototype(JSON.parse(JSON.stringify(this.props.values)), this.props.componentConfig)) !== JSON.stringify(this.state.newProto)) {
                this.setState({
                    newProduct: this.props.newProduct,
                    newProto: this.getPrototype(JSON.parse(JSON.stringify(this.props.values)), this.props.componentConfig)
                });
            }
        }
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    newProduct = async () => {
        if (this.props.values[this.props.componentConfig.idfield] && this.props.values[this.props.componentConfig.prototypefield]) {
            this.modal.show();
        } else {
            this.props.pristineForm();
        }
    }

    getHeader = () => {
        return this.props.values[this.props.componentConfig.idfield] && this.props.values[this.props.componentConfig.prototypefield] ? (this.props.values.newProtoType ? "Új Kiadás adatai" : this.props.values.name) : "Új Termék adatai";
    }

    getFieldProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        if (this.props.values.newProtoType && (this.props.componentConfig.fielddefs[name] || {}).prototype === "prototype") {
            props.disabled = true;
        }
        if (this.props.values.newProtoType && name + "" !== "" + this.props.componentConfig.idfield && !(this.props.componentConfig.fielddefs[name] || {}).prototype) {
            props.required = true;
        }
        if (name === "barcode" && this.props.newProduct) {
            props.disabled = true;
        }
        return props;
    }

    render() {

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        const Form = this.props.formType || ProductForm;
        if (this.props.user.privileges.find(privilege => privilege.name === "all_products") === undefined) {
            var filter = [
                ...(this.props.filter || []),
                {
                    field: "partners",
                    value: this.props.user.partner && this.props.user.partner.partner_id || 0
                }
            ];
        }

        return (
            <Fragment>
                {this.state.newProduct ? <NewProductChooser
                    state={this.props.newProduct ? true : undefined}
                    {...this.props}
                    getPrototype={this.getPrototype}
                    newProto={this.state.newProto}
                    setState={(state,cb) => this.setState(state,cb)}
                /> : <ProductChooser
                    state={this.props.newProduct ? false : undefined}
                    ref={(modal) => this.modal = modal}
                    {...this.props}
                    getPrototype={this.getPrototype}
                    newProto={this.state.newProto}
                    setState={(state,cb) => this.setState(state,cb)}
                />}
                <List
                    {...this.props}
                    pristineForm={this.pristineForm}
                    theme="default"
                    header={"Termékek"}
                    footer={[
                        <Button
                            key="1"
                            disabled={this.props.isLoading}
                            color="default"
                            className="pull-left"
                            onClick={this.newProduct}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <ProductList
                        ref={(el) => this.list = el}
                        {...this.props}
                        checkStockButton={CheckStockButton}
                        pristineForm={this.pristineForm}
                        filter={filter || this.props.filter || []}
                    />
                </List>
                {!this.state.newProduct && <Editor
                    {...this.props}
                    pristineForm={this.pristineForm}
                    theme="default"
                    header={this.getHeader()}
                    footer={[
                        this.props.values[this.props.componentConfig.idfield] ? <CheckStockButton
                            key="1"
                            id={this.props.values[this.props.componentConfig.idfield]}
                            {...this.props}
                        /> : null,
                        this.props.values[this.props.componentConfig.idfield] && this.props.values.label_url ? <a
                            key="2"
                            href={this.props.values.label_url}
                            target="_blank"
                            className="btn btn-default"
                        >
                            <Icon lib="fa" name="print"/> Címke nyomtatás
                        </a> : null,
                        <Button
                            key="0"
                            disabled={ !this.props.dirty || this.props.isLoading }
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>
                    ]}
                >
                    <Form {...this.props} getFieldProps={this.getFieldProps} pristineForm={this.pristineForm} />
                </Editor>}
                <Other>
                    {
                        this.props.user.hasPermission("product_partner_edit") && this.props.values[this.props.componentConfig.idfield] && this.props.componentConfig.fielddefs.partners
                        &&
                        <Box
                            theme="default"
                            header="Partnerek"
                        >
                            <SelectorGrid
                                columns={{
                                    name: {
                                        header: 'Név',
                                        width: 3,
                                        filterable: true,
                                        sortable: true
                                    },
                                    email: {
                                        header: 'Email',
                                        width: 2,
                                        filterable: true,
                                        sortable: true
                                    },
                                    address: {
                                        header: 'Cím',
                                        width: 3,
                                        renderer: AddressFormatter
                                    }
                                }}
                                name="partners"
                                listfieldlabel="name"
                                data={this.props.values}
                                componentConfig={this.props.componentConfig}
                                {...this.props.getFieldProps("partners")}
                            />
                        </Box>
                    }
                </Other>
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till,
        user: state.app.user
    };
}, {})(createEditor({componentName: "product", WrappedComponent: ProductEditor, props: {
        view: "admin",
        componentActions: async (action, data, params, componentConfig) => {
            if (data.newProtoType) {
                action = "create";
                delete action.newProtoType;
            }
            await Promise.all(Object.keys(componentConfig.fielddefs).map(async (fieldname) => {
                if (componentConfig.fielddefs[fieldname].type === "object" && data[fieldname] instanceof Object) {
                    const config = await getComponentConfig(componentConfig.fielddefs[fieldname].object);
                    data[fieldname] = data[fieldname][config.idfield] || null;
                } else if (componentConfig.fielddefs[fieldname].type === "componentlist" && data[fieldname] instanceof Array) {
                    const config = await getComponentConfig(componentConfig.fielddefs[fieldname].objects);
                    data[fieldname] = data[fieldname].map((item) => item[config.idfield] && {[config.idfield]: item[config.idfield]}).filter((item) => !!item);
                }
            }));
            return {action,data};
        }
    }}));

